import styled from 'styled-components'

import { color, media, radius, spacing } from '../../themes'

export const Container = styled.div`
  width: 100%;
  justify-self: center;

  ${media.tablet} {
    min-width: 382px;
    max-width: 452px;
  }
`

export const PointInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
  margin: ${spacing(6, 6, 0)};

  & > div:nth-child(3) {
    margin-top: ${spacing(2)};
    border-top: 1px solid ${color('gray.03')};
    padding-top: ${spacing(2)};
  }
`

export const OverlapList = styled.ul`
  color: ${color('gray.01')};
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
`

export const OverlapListItem = styled.li`
  border: 1px solid ${color('gray.04')};
  border-radius: ${radius('md')};
  width: 100%;
  padding: ${spacing(3, 4)};
  display: flex;
  flex-direction: column;
`
